export default __webpack_public_path__ + "static/media/client-list.c9546d80.svg";